
    export const skyboxTourSteps = [
        {
            target: '[data-tour="skybox-connect-button"]',
            content: 'Click "Connect" to set up your SkyBox POS integration.',
            placement: 'top',
            disableBeacon: false,
        },
       
    ];

    export const skyBoxModalTutorials = [
        {
            target: '[data-tour="skybox-token-link"]',
            content: 'First, click this link to learn how to generate your SkyBox API token.',
            placement: 'bottom',
            disableBeacon: false,
        },
        {
            target: '[data-tour="skybox-token-fields"]',
            content: 'Enter your API Token and Account ID here. You can get these from your SkyBox account settings.',
            placement: 'top',
            disableBeacon: false,
        },
        {
            target: '[data-tour="skybox-start-date"]',
            content: 'Select the start date for data synchronization from your SkyBox account.',
            placement: 'top',
            disableBeacon: false,
        },
        {
            target: '[data-tour="skybox-submit-button"]',
            content: 'Finally, click this button to save your SkyBox integration settings.',
            placement: 'top',
            disableBeacon: false,
        },
        {
            target: '[data-tour="end-skybox-tutorial"]', 
            content: 'Great! Now after you have added token on finish you will be taken to next page where you can sync your data periodically.',
            placement: 'center',
            disableBeacon: false,
        }
    ]

    export const skyBoxPurchaseSyncTutorials = [
        {
            target: '[data-tour="skybox-purchase-sync-button"]',
            content: 'Click this button to sync your SkyBox purchase data.',
            placement: 'top',
            disableBeacon: false,
        }
    ]